import { c as _c } from "react/compiler-runtime";
import type { ChevronProps } from 'react-day-picker';
import { ChevronDownIcon } from '@/components/icons/ChevronDownIcon';
import { cn } from '@/lib/cn';
export function DayPickerChevron(t0) {
  const $ = _c(9);
  const {
    className,
    size,
    orientation,
    disabled
  } = t0;
  const t1 = `text-[${size}px]`;
  const t2 = orientation === "up";
  const t3 = orientation === "left";
  const t4 = orientation === "right";
  let t5;
  if ($[0] !== className || $[1] !== disabled || $[2] !== t1 || $[3] !== t2 || $[4] !== t3 || $[5] !== t4) {
    t5 = cn(t1, {
      "rotate-180": t2,
      "rotate-90": t3,
      "-rotate-90": t4,
      "opacity-50": disabled
    }, className);
    $[0] = className;
    $[1] = disabled;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <ChevronDownIcon className={t5} />;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}